<template>
    <v-app-bar
        app
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        :elevation="0"
        :height="64"
        color="transparent"
        class="glass-nav"
        flat
    >
        <v-btn
            v-if="$vuetify.breakpoint.mdAndDown"
            icon
            color="primary"
            @click="$emit('toggle-drawer')"
        >
            <v-icon>mdi-menu</v-icon>
        </v-btn>

        <router-link
            to="/"
            class="topbar-brand text-decoration-none"
        >
            <div class="topbar-brand-icon">
                <v-img
                    src="@/assets/logo-mini.png"
                    contain
                    width="22"
                    height="22"
                />
            </div>
            <div class="topbar-brand-copy d-flex flex-column">
                <span class="topbar-brand-title">Future Marketing</span>
                <span class="eyebrow">Sites para Saúde</span>
            </div>
        </router-link>

        <v-spacer />

        <theme-toggle class="mr-3" />

        <v-menu
            offset-y
            min-width="220"
            content-class="elevation-0"
            transition="slide-y-transition"
        >
            <template #activator="{ on, attrs }">
                <button
                    class="d-flex align-center cursor-pointer noselect topbar-user"
                    v-bind="attrs"
                    v-on="on"
                >
                    <span
                        v-if="user?.name && $vuetify.breakpoint.smAndUp"
                        class="body-sm text-muted mr-2 one-line-text"
                        style="font-weight:600;max-width:160px"
                    >
                        {{ user.name }}
                    </span>
                    <v-avatar
                        size="36"
                        class="topbar-avatar"
                    >
                        <v-img
                            v-if="user?.profile_picture"
                            :src="user.profile_picture"
                        />
                        <v-icon
                            v-else
                            color="white"
                            size="20"
                        >
                            mdi-account
                        </v-icon>
                    </v-avatar>
                </button>
            </template>

            <v-list dense>
                <v-list-item to="/meu-perfil">
                    <v-list-item-icon>
                        <v-icon>mdi-account-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Meu perfil</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('logout')">
                    <v-list-item-icon>
                        <v-icon color="error">mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Sair</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
export default {
    name: 'AppTopbar',
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
}
</script>

<style scoped>
.topbar-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    margin-right: 24px;
}

.topbar-brand-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dim) 100%);
    box-shadow: var(--shadow-pulse);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.topbar-brand-title {
    font-family: var(--font-display);
    font-weight: 900;
    font-size: 0.95rem;
    color: var(--color-on-surface);
    line-height: 1.1;
    letter-spacing: -0.01em;
}

.topbar-brand-copy {
    min-width: 0;
}

.topbar-user {
    background: transparent;
    border: none;
    padding: 4px 4px 4px 8px;
    border-radius: 9999px;
    transition: background 200ms ease;
}

.topbar-user:hover {
    background: rgba(255, 255, 255, 0.5);
}

.topbar-avatar {
    border: 2px solid rgba(112, 42, 225, 0.18);
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dim) 100%);
}

@media (max-width: 600px) {
    .topbar-brand {
        margin-right: 12px;
    }

    .topbar-brand-copy {
        display: none !important;
    }
}
</style>
